/* eslint-disable camelcase */
import React, { useState } from 'react';
import Tooltip from '../../../Tooltip';

const Departure = ({
  payload,
  price_tooltip_text,
  supplement_tooltip_text,
  contact_link,
  forwardNav,
  setSelectedDeparture,
}) => {
  const { start_date, end_date, button, details, price, single_supplement } =
    payload;

  const [showPriceTooltip, setShowPriceTooltip] = useState(false);

  const [showSupplementTooltip, setShowSupplementTooltip] = useState(false);

  const handleBookNow = () => {
    setSelectedDeparture(payload);
    forwardNav();
  };

  return (
    <tr>
      <td data-th="Start date" className="c-dates__table__cell">
        {start_date}
      </td>

      <td data-th="End date" className="c-dates__table__cell">
        {end_date}
      </td>

      <td
        data-th="Price PP"
        className="c-dates__table__cell c-dates__table__cell--price"
      >
        <span
          className="u-weight--bold u-color--primary"
          dangerouslySetInnerHTML={{ __html: price.display }}
        ></span>
      </td>

      <td className="c-dates__table__cell c-dates__table__cell--flights">
        <span role="presentation" className="c-dates__table__plane"></span>
        Excluding international flights
        <Tooltip show={showPriceTooltip} setShow={setShowPriceTooltip}>
          <p className="o-tooltip-booking__title">
            {details.display} from{' '}
            <span className="u-weight--bold">{price.display}</span>
          </p>

          <div
            className="o-tooltip-booking__text"
            dangerouslySetInnerHTML={{ __html: price_tooltip_text }}
          ></div>

          <a href={contact_link} className="o-btn o-btn--soft-sky--lighter">
            Contact Us
          </a>

          <a
            className="o-tooltip-booking__content__close"
            onClick={() => setShowPriceTooltip(!showPriceTooltip)}
          >
            Close
          </a>
        </Tooltip>
      </td>

      <td
        data-th="Single supplement"
        className="c-dates__table__cell c-dates__table__cell--supplement"
      >
        <span
          className="u-weight--bold u-color--primary"
          dangerouslySetInnerHTML={{ __html: single_supplement.display }}
        ></span>

        <Tooltip
          show={showSupplementTooltip}
          setShow={setShowSupplementTooltip}
        >
          <p className="o-tooltip-booking__title">
            {details.display} from{' '}
            <span className="u-weight--bold">{price.display}</span>
          </p>

          <div
            className="o-tooltip-booking__text"
            dangerouslySetInnerHTML={{ __html: price_tooltip_text }}
          ></div>

          <a href={contact_link} className={' o-btn o-btn--soft-sky--lighter'}>
            Contact Us
          </a>

          <a
            className="o-tooltip-booking__content__close"
            onClick={() => setShowSupplementTooltip(!showSupplementTooltip)}
          >
            Close
          </a>
        </Tooltip>
      </td>

      <td className="c-dates__table__cell c-dates__table__cell--book">
        <button
          href=""
          className={`c-dates__table__book c-dates__table__book--${
            button.sold_out ? 'sold-out' : ''
          } o-btn`}
          onClick={() => !button.sold_out && handleBookNow()}
        >
          {button.text}
        </button>
      </td>
    </tr>
  );
};

export default Departure;
